export const fixFont = (value) => {
  const span = document.createElement('span');
  span.setAttribute('style', value);

  return ['fontWeight', 'fontStyle', 'fontVariant', 'fontSize', 'lineHeight', 'fontFamily'].reduce(
    (font, field) => ({
      ...font,
      [field]: span.style[field],
    }),
    {},
  );
};

export const extractFont = ({value}: {value?: string} = {}) => (value ? fixFont(value) : null);

export const presetGetter = (textPresets) => (preset) => extractFont(textPresets[preset]);

export const withoutSize = (font) => {
  const omitFields = ['fontSize', 'lineHeight'];
  return Object.keys(font).reduce((newFont, fontField) => {
    if (omitFields.includes(fontField)) {
      return newFont;
    }
    return {
      ...newFont,
      [fontField]: font[fontField],
    };
  }, {});
};
